import { WidgetTypes } from "@swiggy-private/dls-react-mxn/dist/WidgetController/constants";
import type { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import { hasType } from "../Menu";

export const hasCTAWidget = (cards: IPLWidgetControllerCards[]) => {
    return cards.some((card) => hasType(card) && card.card.card["@type"] === WidgetTypes.CTA_LIST);
};
